import { makeAutoObservable } from 'mobx';

export enum ModalName {
  CONTACT_US = 'CONTACT_US',
  HIGH_QUALITY_RENDER = 'HIGH_QUALITY_RENDER',
}

class ModalStore {
  modalName: ModalName | null = null;

  private onCloseCallback: (() => void) | null = null;

  constructor() {
    makeAutoObservable(this, undefined, { autoBind: true });
  }

  get hasOpenedModal() {
    return !!this.modalName;
  }

  getIsOpened(modalName: ModalName) {
    return this.modalName === modalName;
  }

  openModal(modalName: ModalName, onClose?: () => void) {
    this.modalName = modalName;

    if (onClose) {
      this.onCloseCallback = onClose;
    }
  }

  closeModal() {
    if (this.onCloseCallback) {
      this.onCloseCallback();
      this.onCloseCallback = null;
    }

    this.modalName = null;
  }

  closeModalByName(modalName: ModalName) {
    if (this.modalName !== modalName) return;

    this.closeModal();
  }
}

export const modalStore = new ModalStore();
